import { render, staticRenderFns } from "./projectResult.vue?vue&type=template&id=1204cc1c&scoped=true"
import script from "./projectResult.vue?vue&type=script&lang=js"
export * from "./projectResult.vue?vue&type=script&lang=js"
import style0 from "./projectResult.vue?vue&type=style&index=0&id=1204cc1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1204cc1c",
  null
  
)

export default component.exports